import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_GET_ASSET_MODELS,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_MODEL_DATA,
} from '../constants';

const api = ({ solutionId, twinId }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_GET_ASSET_MODELS, {
      solutionId,
      twinId,
    }),
  });

const assetModelData = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_MODEL_DATA,
  responseMapping: ResponseMapping.Default,
});

export default assetModelData;
